(function($) {
    'use strict';

    $('.js-search-wrap').each(function() {
        var $container = $(this);
        var $toggle = $container.find('.js-search-toggle');
        var $field = $container.find('.js-search-form input');

        $toggle.on('click', function () {
            $container.addClass('active');
            $field.focus();
        });
        $field.on('blur', function () {
            $container.removeClass('active');
        });
        $(window).on('keyup', function (e) {
            if (e.key === 'Escape') {
                $field.blur();
            }
        });
    });
})(jQuery);
